import { BannerWidget } from '../../domain/models/BannerWidget';
import type { BannerWidgetItemDTO, BannerWidgetResponseDTO } from '../dto/bannerWidget.dto';

/**
 * DTO -> Domain
 */
export function adaptBannerWidgetResponseDtoToDomain(
  dto: BannerWidgetResponseDTO
): BannerWidget[] {
  const items = dto?.data?.widget ?? [];
  return items.map(adaptBannerWidgetItemDtoToDomain);
}

export function adaptBannerWidgetItemDtoToDomain(
  item: BannerWidgetItemDTO
): BannerWidget {
  const imageUrl = item.mobileImageLink || item.imageLink;
  const desktopImageUrl = item.desktopImageLink || null;
  const landingUrl = item.redirectURL || item.landingLink || null;

  return new BannerWidget({
    name: item.name,
    imageUrl,
    desktopImageUrl,
    landingUrl,
    bannerType: item.bannerType,
  });
}

/**
 * Domain -> plain object for Redux serialization
 */
export interface BannerWidgetPlain {
  name: string;
  imageUrl: string;
  desktopImageUrl: string | null;
  landingUrl: string | null;
  bannerType: string;
}

/** Combined cache result stored in RTK Query: widget + browse plain objects */
export interface BannerWidgetCacheResult {
  widget: BannerWidgetPlain[];
  browse: BannerWidgetPlain[];
}

export function adaptBannerWidgetCacheResult(dto: BannerWidgetResponseDTO): BannerWidgetCacheResult {
  const widgetItems = dto?.data?.widget ?? [];
  const browseItems = dto?.data?.browse ?? [];
  return {
    widget: bannerWidgetsToPlainObject(widgetItems.map(adaptBannerWidgetItemDtoToDomain)),
    browse: bannerWidgetsToPlainObject(browseItems.map(adaptBannerWidgetItemDtoToDomain)),
  };
}

export function bannerWidgetsToPlainObject(list: BannerWidget[]): BannerWidgetPlain[] {
  return list.map((item) => ({
    name: item.name,
    imageUrl: item.imageUrl,
    desktopImageUrl: item.desktopImageUrl,
    landingUrl: item.landingUrl,
    bannerType: item.bannerType,
  }));
}

export function bannerWidgetsPlainToDomain(list: BannerWidgetPlain[]): BannerWidget[] {
  return list.map(
    (item) =>
      new BannerWidget({
        name: item.name,
        imageUrl: item.imageUrl,
        desktopImageUrl: item.desktopImageUrl,
        landingUrl: item.landingUrl,
        bannerType: item.bannerType,
      })
  );
}


